import {httpClientV2} from "../../../../infrastructure/http";
import {
  WithdrawalRequest,
  WithdrawalResponse,
  WithdrawalRepository,
} from "../../domain/types";
import {WithdrawalMapperV2} from "../mappers/mapper.v2";
import {V2WithdrawalApiResponse} from "../mappers/mapper.types";

/**
 * v2 API implementation of WithdrawalRepository.
 *
 * Endpoint:
 * - POST payments/withdrawal
 *
 * Pure TypeScript - no React imports.
 */
export class WithdrawalRepositoryV2 implements WithdrawalRepository {
  private readonly endpoint = "payments/withdrawal";

  async initiateWithdrawal(request: WithdrawalRequest): Promise<WithdrawalResponse> {
    const payload = WithdrawalMapperV2.toApiRequest(request);

    const response = await httpClientV2.post<V2WithdrawalApiResponse>(
      this.endpoint,
      payload
    );

    return WithdrawalMapperV2.toDomain(response.data);
  }
}
